import React from 'react'
import { Link } from 'react-router-dom'
import IMS from "../../assets/portfolio/ims.png"
import Tour from "../../assets/portfolio/tour.png"
import Ecom from "../../assets/portfolio/e-com.png"
import Dkper from "../../assets/portfolio/dkeeper.png"
import Opend from "../../assets/portfolio/opend.png"
import Dbank from "../../assets/portfolio/dbank_logo.png"

const Card = (props) => {
    return (
        <div className="w-64 h-64 relative rounded-xl hover:w-72 hover:h-72 shadow-2xl">
            <Link to={props.link} referrerPolicy='true'>
                <img src={props.imgUrl} alt="card-img" className='rounded-xl shadow-xl z-10' />
            </Link>
        </div>
    )
}
export default function PortfolioCards() {
    const cardData = [
        { id: 1, imgUrl: require('../../assets/portfolio/eisytech.png'), link: 'https://eisytech.com' },
        { id: 2, imgUrl: require('../../assets/portfolio/jeomut.png'), link: 'https://jeomut.com' },
        { id: 3, imgUrl: require('../../assets/portfolio/merkezsolar.png'), link: 'https://merkezsolar.com' },
        { id: 4, imgUrl: require('../../assets/portfolio/mkm.png'), link: 'https://mkmelektrikenerji.com' },
        { id: 5, imgUrl: require('../../assets/portfolio/comp1.png'), link: 'https://glistening-rabanadas-a6919d.netlify.app' },
        { id: 6, imgUrl: require('../../assets/portfolio/mel.png'), link: 'https://cheery-tapioca-c73418.netlify.app/' },
        { id: 7, imgUrl: require('../../assets/portfolio/comp2.png'), link: 'https://cerulean-speculoos-ed2fbd.netlify.app/' },
        { id: 8, imgUrl: require('../../assets/portfolio/fisherman.png'), link: 'https://tunahantatli.github.io/fisherman-html-exmpl/' },
        { id: 9, imgUrl: require('../../assets/portfolio/weather.png'), link: 'https://tunahantatli.github.io/weather-site/' },
        { id: 10, imgUrl: require('../../assets/portfolio/todo.png'), link: 'https://tunahantatli.github.io/todoList-project/' },
        { id: 11, imgUrl: require('../../assets/portfolio/tenis.png'), link: 'https://tunahantatli.github.io/table-tennis-js-game/' },
        { id: 12, imgUrl: require('../../assets/portfolio/xox.png'), link: 'https://tunahantatli.github.io/tic-tac-toe/' },
    ]
    return (
        <div className='w-full min-h-[85vh] lg:min-h-[78vh] mt-24'>
            <h2 className='text-left text-[36px] text-gray-300 font-light mb-2'>Website Projects:</h2>
            <div className='flex justify-center items-center'>
                <div className="flex flex-wrap items-center p-8 gap-x-6 gap-y-4 justify-center ">
                    {cardData.map((card) => (
                        <Card key={card.id} link={card.link} imgUrl={card.imgUrl} />
                    ))}
                </div>
            </div>
            <div>
                <h2 className='text-left text-[36px] text-teal font-light mt-2 mb-2'>Backend Projects:</h2>
                <p className='text-justify text-gray-300'>
                    Django is a Python-based web framework and an ideal tool for developing fast, reliable web applications.
                    It implements the Model-View-Controller (MVC) architecture in the form of Model-View-Template (MVT) and includes
                    many features from database operations to URL redirects. It facilitates the development process with its clean
                    and organized code structure. Database operations are simplified with the powerful ORM (Object-Relational Mapping)
                    feature. Django includes automatic security measures and is scalable. With the rich library and community support
                    that Django offers, it is possible to quickly develop complex web applications.
                </p>
                <ul className='mt-2 mb-2'>
                    <li className='mb-2'>
                        <div className='md:flex gap-x-2 gap-y-3 justify-center-items-center rounded-md border-[3px]'>
                            <div className='md:w-2/5 justify-center items-center'>
                                <img src="https://th.bing.com/th/id/OIP.p_T_wtF71a9vaImWPYLs4gHaEs?rs=1&pid=ImgDetMain" alt="flight" className='w-full rounded-md' />
                            </div>
                            <div className='p-2 md:w-3/5'>
                                <h3 className='text-[22px] text-info text-left font-normal'>Flight Reservation App</h3>
                                <p className='text-justify text-gray-300 text-[17px] font-light'>
                                    In this project, it is aimed to create an application users can create, update, delete or read reservations.
                                    Nested serializers are used to create objects on two different tables at the same time.
                                    Also, we used class-based views and overridden some methods to create custom functionalities.
                                </p>
                            </div>
                        </div>
                    </li>
                    <li className='mb-2'>
                        <div className='md:flex gap-x-2 gap-y-3 justify-center-items-center rounded-md border-[3px]'>
                            <div className='md:w-2/5 justify-center items-center'>
                                <img src={IMS} alt="flight" className='w-full rounded-md' />
                            </div>
                            <div className='p-2 md:w-3/5'>
                                <h3 className='text-[22px] text-info text-left font-normal'>Inventory Management System</h3>
                                <p className='text-justify text-gray-300 text-[17px] font-light'>
                                    This project includes an Inventory Management System (IMS) that I developed using Bootstrap 5
                                    and Django Model-View-Template (MVT) architecture.
                                    IMS provides a platform where users can add products, categories and units to their inventory.
                                </p>
                                <ul className='pl-12 text-[17px] text-gray-300 list-disc font-light'>
                                    <li>Users can add products to their inventory.</li>
                                    <li>Users can determine the category and unit of the products they add.</li>
                                    <li>New categories and units can be added.</li>
                                    <li>A modern and responsive user interface was designed with Bootstrap 5.</li>
                                </ul>
                                <p className='text-justify text-[17px] text-gray-300 font-light'>
                                    This project addresses real-world use cases while providing a unique experience using the powerful structure of Django and the
                                    flexible design of Bootstrap.
                                </p>
                            </div>
                        </div>
                    </li>
                    <li className='mb-2'>
                        <div className='md:flex gap-x-2 gap-y-3 justify-center-items-center rounded-md border-[3px]'>
                            <div className='md:w-2/5 justify-center items-center'>
                                <img src={Tour} alt="flight" className='w-full rounded-md' />
                            </div>
                            <div className="p-2 md:w-3/5">
                                <h3 className='text-[22px] text-info text-left font-normal' >TOUR APP</h3>
                                <p className='text-[17px] text-gray-300 text-justify font-light'>
                                    Tour app project is a web platform prepared for nature enthusiasts. On this platform, you
                                    can see different treking routes added by the admin, choose the routes you want to join as a
                                    member and communicate with other members. The platform was developed with Django and bootstrap
                                    was used for the interface.
                                    All contents (text, images, files, etc.) on the website were added by the admin. It is also possible to create 
                                    content in html format on the admin page. 
                                    The platform is not yet live. The project process, which consists of stages
                                    such as trekking routes and determination of
                                    rest and accommodation facilities, continues. But if you want such a platform, you can contact me.
                                </p>
                            </div>
                        </div>
                    </li>
                    <li className='mb-2'>
                        <div className='md:flex gap-x-2 gap-y-3 justify-center-items-center rounded-md border-[3px]'>
                            <div className='md:w-2/5 justify-center items-center'>
                                <img src={Ecom} alt="flight" className='w-full rounded-md' />
                            </div>
                            <div className='p-2 md:w-3/5'>
                                <h3 className='text-[22px] text-info text-left font-normal'>E-Commerce Site Project with Django</h3>
                                <p className='text-[17px] text-gray-300 text-justify font-light'>
                                    In this project, I developed an e-commerce site with Django. In the backend of the site, I created APIs
                                    with Django Rest Framework. In the frontend of the site, I made a modern and responsive design with Bootstrap 5.
                                    The site has features such as listing products, viewing details, adding to cart, placing an order, becoming a
                                    member, logging in, editing profile, and viewing past orders. Additionally, I can manage products, users and
                                    orders from the admin panel. The only missing part of the site is the payment page. I will not complete this
                                    part. If you would like to see or purchase the project, please contact me.
                                </p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <h2 className='text-left text-[36px] text-amber font-light mt-2 mb-2'>Blockchain Projects:</h2>
            <p className='text-justify text-warning'>
                Blockchain development is a new and complex technology. Reactjs and Motoko are popular and powerful
                technologies for building web3 applications. Blockchain provides a decentralized, encrypted, verifiable
                and immutable database. I believe that Blockchain will both transform existing industries and create new ones,
                and Blockchain developers will be at the forefront of this change.
            </p>
            <ul className='mt-2 mb-2'>
                <li className='mb-2'>
                    <div className='md:flex gap-x-2 gap-y-3 justify-center-items-center rounded-md border-[3px]'>
                        <div className='md:w-2/5 justify-center items-center'>
                            <img src={Opend} alt="flight" className='w-full rounded-md' />
                        </div>
                        <div className='p-2 md:w-3/5'>
                            <h3 className='text-[22px] text-indigo text-left font-normal'>Opend</h3>
                            <p className='text-justify text-gray-300 text-[17px] font-light'>
                                Opend is a web3 marketplace for NFTs and crypto collectibles.
                                With Opend, you can discover, create, buy, sell and auction NFTs. Opend's front end is developed
                                with react js, and its back end is developed with motoko, a programming language designed for web3
                                applications. Opend is an unfinished project, but development is ongoing. You can access the github
                                repo address of this project <a href="http://https://github.com/tunahantatli/opend" className='text-purple'>here</a>.
                            </p>
                        </div>
                    </div>
                </li>
                <li className='mb-2'>
                    <div className='md:flex gap-x-2 gap-y-3 justify-center-items-center rounded-md border-[3px]'>
                        <div className='md:w-2/5 justify-center items-center'>
                            <img src={Dkper} alt="flight" className='w-full rounded-md' />
                        </div>
                        <div className='p-2 md:w-3/5'>
                            <h3 className='text-[22px] text-indigo text-left font-normal'>DKeeper</h3>
                            <p className='text-justify text-gray-300 text-[17px] font-light'>
                                Dkeeper is a web3 application that enables note keeping, sharing and management using blockchain technology.
                                With Dkeeper, you can easily create, edit, delete, colorize and categorize your notes. Dkeeper's front end is
                                developed with React js, and its back end is developed with Motoko, a programming language designed for web3
                                applications. Dkeeper is a project suitable for hosting on the
                                ICP (Internet Computer) blockchain. You can access the github repo address of this project <a href="https://github.com/tunahantatli/dkeeper" className='text-purple'>here</a>.
                            </p>
                        </div>
                    </div>
                </li>
                <li className='mb-2'>
                    <div className='md:flex gap-x-2 gap-y-3 justify-center-items-center rounded-md border-[3px]'>
                        <div className='md:w-2/5 justify-center items-center'>
                            <img src={Dbank} alt="flight" className='w-full rounded-md' />
                        </div>
                        <div className='p-2 md:w-3/5'>
                            <h3 className='text-[22px] text-indigo text-left font-normal'>DBank</h3>
                            <p className='text-justify text-gray-300 text-[17px] font-light'>
                                Dbank allows users to earn passive income with an interest rate determined according to their token balance.
                                Dbank's front end is developed with React js, and its back end is developed with Motoko, a programming language
                                designed for web3 applications.
                                Dbank is a project suitable for hosting on the ICP (Internet Computer) blockchain.
                            </p>
                        </div>
                    </div>

                </li>
            </ul>
        </div>

    )
}
